import { render, staticRenderFns } from "./CounterpartyContact.vue?vue&type=template&id=2656b8e2&scoped=true"
import script from "./CounterpartyContact.vue?vue&type=script&lang=js"
export * from "./CounterpartyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2656b8e2",
  null
  
)

export default component.exports